Namespace 'ScheduledReports'

class ScheduledReports.Result extends Backbone.Model
  urlRoot: 'scheduled_reports/results/'

  defaults:
    created_at: ''
    updated_at: ''
    report_description: ''
    serialized_report_configuration: ''
    result_file_url: ''
    error_message: null

  hasFailed: ->
    @get('error_message') != null

class ScheduledReports.Results extends Backbone.Collection
  url: 'scheduled_reports/results/'
  model: ScheduledReports.Result
